// /**
//  * 仓储管理模块路由。
//  * 当前先挂载库位管理页面，后续仓库、库区等页面也可以继续挂到这个模块下。
//  */
// const wmsRouter = [
//   {
//     // 仓储管理一级路由，统一使用主布局组件承载。
//     path: '/wms',
//     component: () => import('@/layout/LayoutIndex.vue'),
//     meta: { title: '浠撳偍绠＄悊', icon: 'system', requireAuth: true },
//     name: 'wms',
//     redirect: '/home',
//     children: [
//       {
//         // 库位管理页面路由。
//         path: '/wms/warehouseBin',
//         component: () => import('@/views/goods/warehouseBin/WarehouseBinIndex.vue'),
//         name: 'WarehouseBinIndex',
//         meta: { title: '搴撲綅绠＄悊', requireAuth: true }
//       }
//     ]
//   }
// ]

// export default wmsRouter


// 引入布局组件
import LayoutIndex from '@/layout/LayoutIndex.vue';

// 定义路由常量
const storageRouter = [
  {
    path: '/wms',
    component: LayoutIndex,
    meta: { title: '仓储管理', icon: 'wms', requireAuth: true },
    name: 'wms',
    redirect: '/wms/home',
    children: [
      // 1. 修复的路由：仓库管理 (warehouses.vue)
      {
        path: '/wms/warehouse', // 访问路径
        // 关键修正：路径必须与你实际的 .vue 文件位置完全一致
        component: () => import('@/views/goods/warehouse/warehouses.vue'),
        name: 'Warehouses', // 组件名，建议与文件名一致
        meta: { title: '仓库管理', requireAuth: false }
      },
      // 2.库区管理路由
      {
        path: '/wms/warehouseAreas',
        component: () => import('@/views/goods/warehouseAreas/warehouseAreas.vue'),
        name: 'warehouseAreas',
        meta: { title: '库区管理', requireAuth: false }
      },
      // 2. 保留你原有的库位管理路由（如果有的话）
      {
        path: '/wms/warehouseBin',
        component: () => import('@/views/goods/warehouseBin/WarehouseBinIndex.vue'),
        name: 'WarehouseBin',
        meta: { title: '库位管理', requireAuth: false }
      }
    ]
  }
];

// 导出路由
export default storageRouter;